import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { useLocation, useNavigate } from 'react-router-dom';

import DefaultLayout2021 from './DefaultLayout2021';
import LandingPage from './LandingPage';
import { selectedThemeAtom } from '../../theme/ThemeAtom';
import { useSitemap } from '../../helpers/atoms/SitemapAtom';
import { Page } from '../../helpers/Sitemap';
import ApiExplorerLayout from './apiexplorer/ApiExplorerLayout';
import { enforceAccessControl } from '../../helpers/EnvironmentAccessControl';

export default function LayoutController() {
	const theme = useRecoilValue(selectedThemeAtom());
	const [page, setPage] = useState<Page>();
	const location = useLocation();
	const sitemap = useSitemap();
	const navigate = useNavigate();

	useEffect(() => {
		// enforce access control based on environment
		if (enforceAccessControl()) {
			// User got redirected, don't continue with normal routing
			return;
		}

		// Truncate known page file extensions and redirect
		let newPathName = '';
		if (location.pathname.toLowerCase().endsWith('.md')) {
			newPathName = location.pathname.substring(0, location.pathname.length - 3);
		} else if (location.pathname.toLowerCase().endsWith('.html')) {
			newPathName = location.pathname.substring(0, location.pathname.length - 5);
		}
		if (newPathName) {
			// Append fragment and query string
			if (location.search) {
				if (!location.search.startsWith('?')) newPathName += '?';
				newPathName += window.location.search;
			}
			if (location.hash) {
				if (!location.hash.startsWith('#')) newPathName += '#';
				newPathName += window.location.hash;
			}

			// Navigate and replace to avoid adding to browser history
			navigate(newPathName, { replace: true });
			return;
		}

		if (!page || page.link.toLowerCase() !== location.pathname.toLowerCase()) {
			const newPage = sitemap.getPage(location.pathname) as Page;
			setPage(newPage);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location, sitemap]);

	let layout = page?.layout || 'default';

	switch (layout) {
		case 'landingpage': {
			layout = <LandingPage />;
			break;
		}
		case 'apiexplorer': {
			layout = <ApiExplorerLayout />;
			break;
		}
		default: {
			if (page?.layout && page?.layout !== 'default') console.warn('Unrecognized layout:', layout);
			layout = <DefaultLayout2021 />;
		}
	}

	// Set theme directly on body to ensure the theme can style everything in the layout
	document.body.className = theme;

	return <div>{layout}</div>;
}
